import React from 'react'
import { Icon, Popup } from 'semantic-ui-react'

/**
 * Un documento de factura (del apartado de Facturas o de los documentos de origen:
 * facturación Lizen, factura a cliente, archivos de facturación Orion, documentos de
 * clínica) está bloqueado cuando tiene archivo pero el backend no lo dejó ver:
 * lo cargó otro usuario y no se tiene el permiso `view_todas_facturas`.
 */
export const facturaBloqueada = (doc) =>
  Boolean(doc && typeof doc === 'object' && doc.tiene_archivo && doc.puede_ver === false)

/** Reemplaza el link al archivo cuando la factura está bloqueada para el usuario. */
export const FacturaBloqueada = ({ cargadoPor, children, style }) => (
  <Popup
    content="Solo el usuario que la cargó puede abrirla"
    trigger={
      <span style={{ color: 'grey', ...style }}>
        <Icon name="lock" />
        {children || 'Factura'} cargada por {cargadoPor || 'otro usuario'}
      </span>
    }
  />
)
